import App from '.'
import CGU from './pages/cgu'
import DataPrivacy from './pages/dataPrivacy'
import Demenagement from './pages/demenagement'
import LiMove from './pages/LiMove'
import GroupWebsites from './pages/groupWebsites'
import ClassementReferencement from './pages/classementReferencement'
import Contact from './pages/contact'

export default [
  {
    component: App,
    routes: [
      {
        alias: 'cgu',
        path: '/Conditions_Generales_d_Utilisation.html',
        exact: true,
        component: CGU,
      },
      {
        alias: 'groupwebsites',
        path: '/les-sites-du-groupe',
        exact: true,
        component: GroupWebsites,
      },
      {
        alias: 'classementreferencement',
        path: '/classement_referencement.htm',
        exact: true,
        component: ClassementReferencement,
      },
      {
        alias: 'dataprivacy',
        path: '/CGU_politique_de_confidentialite.html',
        exact: true,
        component: DataPrivacy,
      },
      {
        alias: 'demenagement_formulaire',
        path: '/demenagement_formulaire',
        exact: true,
        component: Demenagement,
      },
      {
        alias: 'demenagement',
        path: '/demenagement',
        exact: true,
        component: LiMove,
      },
      {
        alias: 'contact',
        path: '/contact.html',
        exact: true,
        component: Contact,
      },
    ],
  },
]
